<script>
  import Hamburger from "./Hamburger.svelte";
  import SidebarMobile from "./SidebarMobile.svelte";

  let showSidebar = false;
</script>

<SidebarMobile bind:open={showSidebar} />
<div>
  <Hamburger bind:open={showSidebar} />
</div>
